import React,{useState, useEffect} from 'react'
import {Box,TextInput, Form, FormField,Select} from 'grommet'
import {User, MailOption, Lock} from 'grommet-icons';
import { APIRequest } from './utils/shared/requests';
import {RequestButton} from './utils/shared/shipmentViewFunctions'

function LabUserForm (props) {   
    const [customers, setCustomers] = useState([]);
    useEffect(() => {    
        APIRequest('/lab_customers').then(result => setCustomers(result))
     },[]);
  return ( 
    <Form value={props.value} onSubmit={props.handleSubmit} onChange={nextValue => props.handleChange(nextValue)}>
    <Box direction='row' justify="center" flex="grow" margin={{top: 'large'}}>
        <FormField required label='Username' name='username' margin='small' > <TextInput icon={<User />} name='username' placeholder="Enter Username" /> </FormField>
        <FormField required label='Email' name='email' margin='small' > <TextInput icon={<MailOption />} name='email' placeholder="Enter Email" /> </FormField>
        <FormField required label='Password' name='password' margin='small' > <TextInput icon={<Lock />} name='password' type='password' placeholder="Enter Password" /> </FormField>
        <FormField name="customer" label="Select Customer" margin='small'> <Select id="select" placeholder={`${props.customer.name}`}labelKey="name" options={customers} value={props.customer} onChange={({ option }) => props.handleCustomerChange(option)} /> </FormField>
    </Box>
    <Box direction='row' justify="center" margin={{top: 'medium'}}> <RequestButton load={props.load} label={props.label} /> </Box>
   </Form>

  )
}

export default LabUserForm
